import styled from 'styled-components'

export const ProgressBar = styled.div`
    width: ${props => (props.rowReverse ? '130px' : '86px')};

    .oh-rrc-progress-bar-text {
        font-size: 4.5em;
        stroke: #fff;
    }
`
